import React from 'react';
import { Container, Typography, Box, IconButton, Link, Divider } from '@mui/material';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CookiePolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <Box className="page-header">
        <Box className="title-row">
          <IconButton onClick={() => navigate(-1)} aria-label="go back">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" component="h1" className="page-title">Cookie Policy</Typography>
        </Box>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Last updated: January 31, 2026
      </Typography>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>What Are Cookies</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Cookies are small text files stored on your device by your web browser. Similar technologies
          include localStorage and sessionStorage, which allow websites to store data locally in your
          browser. This policy covers all such storage mechanisms used by Grocery Price Checker.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>How We Use Cookies & Local Storage</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          We use browser storage for the following purposes:
        </Typography>
        <Typography variant="body2" color="text.secondary" component="div">
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <li><strong>Authentication</strong> - JWT tokens are stored in localStorage to keep you signed in</li>
            <li><strong>Analytics session IDs</strong> - A hashed session identifier is stored to track anonymous usage patterns</li>
            <li><strong>Theme preference</strong> - Your light/dark mode preference is saved locally</li>
          </ul>
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Third-Party Cookies</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Google reCAPTCHA is used on our contact form for spam protection. reCAPTCHA may set cookies
          in your browser as part of its bot detection process. These cookies are governed by{' '}
          <Link href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" underline="hover">
            Google's Privacy Policy
          </Link>.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Analytics Tracking</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Our analytics are privacy-focused. We do not collect any personally identifiable information (PII).
          Browser fingerprints are hashed before storage, making them non-reversible. We use bot filtering
          to ensure analytics data reflects real user activity. No data is shared with third-party
          advertising or tracking services.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Managing Cookies</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          You can control cookies through your browser settings. Most browsers allow you to block or
          delete cookies. You can also clear localStorage data through your browser's developer tools
          or settings. Note that clearing authentication tokens will sign you out of the service.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Contact</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          If you have questions about this Cookie Policy, please{' '}
          <Link component={RouterLink} to="/contact" underline="hover">contact us</Link>.
        </Typography>
      </Box>
    </Container>
  );
};

export default CookiePolicy;
